import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e6033ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "WarehouseCreate" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_4 = { class: "border bg-white px-6 py-4 mt-6" }
const _hoisted_5 = { class: "grid grid-cols-3 gap-3" }
const _hoisted_6 = { class: "mt-4" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Укажите адрес", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-400" }, "Для указания адреса, нажмите на карте", -1))
const _hoisted_9 = { class: "mt-2 relative" }
const _hoisted_10 = {
  key: 0,
  class: "absolute right-3 top-3 flex flex-col z-10",
  style: {"min-width":"264px"}
}
const _hoisted_11 = {
  key: 0,
  class: "flex flex-col items-center justify-center mt-3 select-none text-sm text-gray-400 bg-white border p-3"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Поиск результатов...", -1))
const _hoisted_13 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_14 = { key: 2 }
const _hoisted_15 = {
  key: 0,
  class: "border text-sm bg-white mt-3 max-h-40 overflow-hidden overflow-y-auto"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "font-semibold" }
const _hoisted_18 = { class: "font-xs text-gray-500" }
const _hoisted_19 = { class: "WarehouseCreate__schedule" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "WarehouseCreate__schedule__title" }, "График работы", -1))
const _hoisted_21 = { class: "mt-6 flex items-center justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_loader = _resolveComponent("loader")!
  const _component_new_map = _resolveComponent("new-map")!
  const _component_the_time = _resolveComponent("the-time")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, {
        title: `Редактирование склада (${
                    _ctx.state.warehouse ? _ctx.state.warehouse.titleRu : '-'
                })`
      }, null, 8, ["title"]),
      _createVNode(_component_the_button, {
        class: "second text small",
        onClick: _ctx.onBack
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Назад ")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_the_select, {
          placeholder: "Подразделение",
          class: "mt-2",
          loading: _ctx.data_state.subdivisions.is_loading,
          failed: _ctx.data_state.subdivisions.is_failed,
          "error-text": "При получении списка подразделений произошла ошибка",
          options: _ctx.data_state.subdivisions.list,
          "is-invalid": _ctx.state_form$.subdivisionId.$error,
          "validation-errors": _ctx.state_form$.subdivisionId.$errors,
          value: _ctx.state.subdivisionId,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.subdivisionId) = $event)),
          onRefresh: _ctx.loadSubdivisions
        }, null, 8, ["loading", "failed", "options", "is-invalid", "validation-errors", "value", "onRefresh"]),
        _createVNode(_component_the_select, {
          class: "mt-2",
          placeholder: "Город",
          loading: _ctx.data_state.cities.is_loading,
          failed: _ctx.data_state.cities.is_failed,
          "is-invalid": _ctx.state_form$.cityId.$error,
          "validation-errors": _ctx.state_form$.cityId.$errors,
          "error-text": "При получении списка городов произошла ошибка",
          options: _ctx.data_state.cities.list,
          value: _ctx.state.cityId,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.cityId) = $event)),
          onRefresh: _ctx.loadCities
        }, null, 8, ["loading", "failed", "is-invalid", "validation-errors", "options", "value", "onRefresh"]),
        _createVNode(_component_the_input, {
          value: _ctx.state.titleRu,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.titleRu) = $event)),
          "is-invalid": _ctx.state_form$.titleRu.$error,
          "validation-errors": _ctx.state_form$.titleRu.$errors,
          placeholder: "Название склада"
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          value: _ctx.state.fullNameRu,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.fullNameRu) = $event)),
          "is-invalid": _ctx.state_form$.fullNameRu.$error,
          "validation-errors": _ctx.state_form$.fullNameRu.$errors,
          placeholder: "Ответственное лицо"
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          value: _ctx.state.fullAddressRu,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.fullAddressRu) = $event)),
          "is-invalid": _ctx.state_form$.fullAddressRu.$error,
          "validation-errors": _ctx.state_form$.fullAddressRu.$errors,
          placeholder: "Полный адрес"
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          value: _ctx.state.streetRu,
          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.streetRu) = $event)),
          "is-invalid": _ctx.state_form$.streetRu.$error,
          "validation-errors": _ctx.state_form$.streetRu.$errors,
          placeholder: "Улица"
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          value: _ctx.state.house,
          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.house) = $event)),
          placeholder: "Дом"
        }, null, 8, ["value"]),
        _createVNode(_component_the_input, {
          value: _ctx.state.office,
          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.office) = $event)),
          placeholder: "Офис"
        }, null, 8, ["value"]),
        _createVNode(_component_the_input, {
          value: _ctx.state.index,
          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.index) = $event)),
          placeholder: "Индекс"
        }, null, 8, ["value"]),
        _createVNode(_component_the_input, {
          value: _ctx.state.email,
          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.email) = $event)),
          "is-invalid": _ctx.state_form$.email.$error,
          "validation-errors": _ctx.state_form$.email.$errors,
          placeholder: "Почта"
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          value: _ctx.state.phone,
          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.phone) = $event)),
          placeholder: "Телефон",
          maska: _ctx.PHONE_NUMBER_MASK
        }, null, 8, ["value", "maska"]),
        _createVNode(_component_checkbox, {
          label: "Скрывать",
          value: _ctx.state.isHidden,
          "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.isHidden) = $event))
        }, null, 8, ["value"]),
        _createVNode(_component_checkbox, {
          label: "Терминал",
          value: _ctx.state.isTerminal,
          "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.isTerminal) = $event)),
          "return-integer": ""
        }, null, 8, ["value"]),
        _createVNode(_component_checkbox, {
          label: "Экспресс доставка",
          value: _ctx.state.expressEnabled,
          "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.expressEnabled) = $event)),
          "return-integer": ""
        }, null, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          (_ctx.state.is_center_map_ready)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_the_input, {
                  value: _ctx.search_state.query,
                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.search_state.query) = $event)),
                  placeholder: "Поиск",
                  onInput: _ctx.geocode
                }, null, 8, ["value", "onInput"]),
                (
                                _ctx.search_state.is_loading ||
                                _ctx.search_state.is_failed ||
                                (_ctx.search_state.results.length === 0 && Boolean(_ctx.search_state.query))
                            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      (_ctx.search_state.is_loading)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(_component_loader, { class: "primary" }),
                            _hoisted_12
                          ], 64))
                        : (_ctx.search_state.is_failed)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Произошла ошибка, попробуйте еще раз "))
                          : (
                                    _ctx.search_state.results.length === 0 && Boolean(_ctx.search_state.query)
                                )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, " По вашему запросу ничего не найдено "))
                            : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (Boolean(_ctx.search_state.query))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.search_state.results, (result, i) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: `result-${i}`,
                                class: "transition-all px-3 py-2 border-t hover:bg-blue-50 cursor-pointer",
                                onClick: ($event: any) => (_ctx.onSelectAddress(result))
                              }, [
                                _createElementVNode("div", _hoisted_17, _toDisplayString(result.name), 1),
                                _createElementVNode("div", _hoisted_18, _toDisplayString(result.description), 1)
                              ], 8, _hoisted_16))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_new_map, {
            id: "center-map",
            controls: ['zoomControl'],
            zoom: 10,
            onMapReady: _ctx.onMapReady,
            onClick: _ctx.onMapClick
          }, null, 8, ["onMapReady", "onClick"])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.schedules, (schedule, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `schedule-${schedule.weekday}-${idx}`,
            class: "WarehouseCreate__schedule__schedule"
          }, [
            _createElementVNode("div", null, _toDisplayString(_ctx.WEEK_DAYS[schedule.weekday]), 1),
            _createVNode(_component_the_time, {
              placeholder: "Начало рабочего дня",
              value: schedule.workTimeFrom,
              "onUpdate:value": ($event: any) => ((schedule.workTimeFrom) = $event)
            }, null, 8, ["value", "onUpdate:value"]),
            _createVNode(_component_the_time, {
              placeholder: "Конец рабочего дня",
              value: schedule.workTimeUntil,
              "onUpdate:value": ($event: any) => ((schedule.workTimeUntil) = $event)
            }, null, 8, ["value", "onUpdate:value"])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_the_button, {
          disabled: _ctx.state.is_loading,
          loading: _ctx.state.is_loading,
          class: "small primary",
          onClick: _ctx.updateWarehouse
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Редактировать ")
          ]),
          _: 1
        }, 8, ["disabled", "loading", "onClick"])
      ])
    ])
  ]))
}